<div class="row">
  <div class="field">
    <div id="dismissible-tag" class="tag-list">
      <ng-container *ngFor="let field of selectedFields$ | async; trackBy: trackByKey">
        <span
          [@slide]="field.key"
          class="tag is-dismissible"
          style="padding-right: 0px"
          id="{{ ViewerConstants.Tag.automationId + '_' + field.key }}"
          [attr.data-automation-id]="ViewerConstants.Tag.automationId + '_' + field.key"
          title="{{ field.key }} ({{ field.value }})"
          ><span>{{ field.value }}</span>
          <button style="background-color: transparent" soho-button="icon" icon="close-small" (click)="onRemoveField(field.key)">Remove Field</button>
        </span>
      </ng-container>
    </div>
  </div>
</div>
